import { getBoxIntersections, getShelfIntersections } from '@/Engine/intersections';
import { $ } from '@/Engine/state';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { ShelfSet } from '@/Engine/Wardrobe/ShelfSet';
import { PerforatedPanel } from '@/Engine/Wardrobe/PerforatedPanel';
import { useUIOnlyStore } from '@/Store/storeUI';

export const selectObject = (item: RackModule | ShelfSet | PerforatedPanel) => {
    if (item instanceof RackModule && item.onRailGroup) {
        $.selectionBox.selectGroup([ ...item.stackedModules ]);
    } else {
        item.select();
    }
    let label;
    // TODO размеры группы
    if (item.type === 'rackModule' && item.railGroup?.racks.length > 1) {
        label = 'Группа секций';
    } else
    if (item.type === 'rackModule') {
        label = 'Секция';

    } else if ([ 'door', 'window' ].includes(item.type)) {
        label = item.type === 'door'? 'Дверь': 'Окно';
    } else if (item.type === 'box') {
        label = 'Куб';
    }
    else {
        label = item?.humanName;
    }

    useUIOnlyStore().setSelectedSceneObject(
        item.uuid,
        label,
        `${(item.width * 1000).toFixed()}x${(item.height * 1000).toFixed()}x${(item.depth * 1000).toFixed()}`,
        item.rodAvailable,
        !!item.items?.rod,
    );
    useUIOnlyStore().setElementInfoActive(true);
};

export const onClickSelection = () => {
    const intersections = getBoxIntersections();
    const shelfIntersections = getShelfIntersections();
    let selected = false;
    // Если есть пересечение с полкой, выделяем полку
    if (shelfIntersections[0]?.object.userData.parent) {
        selectObject(shelfIntersections[0].object.userData.parent);

        selected = true;
        $.selection = true;
    } else
        // Иначе если есть пересечение с модулем выделяем модуль
    if (intersections[0]?.object.userData.parent) {
        if (intersections[0]?.object.userData.parent.type === 'rackModule') {
            // Если у модуля одна полка, то выделяем полку
            const module = intersections[0].object.userData.parent as RackModule;
            if (module.shelves.length === 1) {
                selectObject(module.shelves[0]);
            } else {
                selectObject(module);
            }
        }
        else {
            selectObject(intersections[0]?.object.userData.parent);
        }
        selected = true;
        $.selection = true;
    }

    // if (intersections[0]?.object.userData.parent && !selected) {
    //     selectObject(intersections[0].object.userData.parent);
    //     selected = true;
    //     $.selection = true;
    // }

    if (!selected) {
        $.selection = false;
        $.selectionBox.unselect();
        $.selectionBoxForBox.unselect();
        useUIOnlyStore().unselect();
    }
};
